import MarkdownIt from 'markdown-it';
import React, { useContext, useEffect } from 'react';
import { useStreamedTextQuery } from '../../../../api/ApiStreaming';
import { EditorSession } from '../../../canvas/EditorSession';
import { Selection } from '../../../canvas/Selection';
import { useResolve } from '../../../Container';
import { Copy } from '../../../dashboard/elements/LayoutElements';
import { AssistantContext } from '../AssistantButtonWidget';
import { Chat } from '../Chat';

const md = new MarkdownIt('default', { linkify: true });

const stripCodeBlock = (text: string) => {
    text = text.trim();
    if (text.startsWith('```markdown')) text = text.slice(11);
    if (text.startsWith('```')) text = text.slice(3);
    if (text.endsWith('```')) text = text.slice(0, -3);
    return text.trim();
};

export const ProductHelpInteraction = ({ input }: { input: string }) => {

    const { state, onSubmit } = useContext(AssistantContext);
    const session = useResolve(EditorSession);
    const [reply, triggerReply, done] = useStreamedTextQuery<{ code: string, message: any }>('/llm.invokeCapability');

    // Start
    useEffect(() => {

        const selection = session.get(Selection);
        const asMessage = selection.size === 0 ? [] : [
            { type: 'text', value: 'Here is some data I have selected on my board:' },
            { type: 'text', value: JSON.stringify(Array.from(selection).map(x => x.toJson()), null, 2) },
        ];

        const message = [
            ...asMessage,
            { type: 'text', value: input },
        ];

        triggerReply({ code: 'product_help', message });
    }, []);

    // Tick
    useEffect(() => {
        state.mutate(x => void (x.tick++));
    }, [reply, done]);

    return <Chat.Block actor={<Chat.Seb />}>
        <Chat.Message>
            {reply && <Copy flush dangerouslySetInnerHTML={{ __html: md.render(stripCodeBlock(reply)) }} />}
            {!reply && <Copy>Using Product Help Capability...</Copy>}
        </Chat.Message>
        {/* {done &&
            <Chat.Actions>
                <Button onAction={onSave}>
                    Save to Jira
                </Button>
                <Button onAction={() => onSubmit(input)}>
                    Repeat
                </Button>
            </Chat.Actions>
        } */}
    </Chat.Block>;
};
